import TokenRenewalBox from '@components/token-renewal-box/token-renewal-box.component'
import { Campaign, UserInDetails, defaultImage } from '@hub/shared'
import React, { useCallback } from 'react'
import './campaign-head-mobile.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
  user: UserInDetails
  onEmitTokenValid?: (tokenValid: boolean) => any
}

export default ({ className = '', style = {}, campaign, user, onEmitTokenValid }: Props) => {
  if (!campaign) {
    return null
  }

  const handleFormatUrl = useCallback((cdnUrl: string, url: string) => {
    return url && url?.startsWith('http') ? url : cdnUrl + url
  }, [])

  return (
    <div>
      <div className={`campaign-head-mobile ${className}`} style={style}>
        <figure className="campaign">
          <img
            src={
              campaign?.activation?.brandLogo
                ? handleFormatUrl(campaign?.activation?.brandPicture?.cdnUrl, campaign?.activation?.brandPicture?.url)
                : handleFormatUrl(campaign?.activation?.logo?.cdnUrl, campaign?.activation?.logo?.url)
            }
            className="img-fluid"
            title="Campaign Avatar"
            alt="Campaign Avatar"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = defaultImage
            }}
          />
        </figure>
        <h1 title={campaign?.exhibitionName}>{campaign?.exhibitionName}</h1>
        {user ? (
          <figure className="user">
            <img
              src={`https://storage.googleapis.com/squid-profile-pictures/${user?.idNetwork}.jpg`}
              className="img-fluid"
              title={user?.username || 'User Avatar'}
              alt={user?.username || 'User Avatar'}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = defaultImage
              }}
            />
          </figure>
        ) : null}
      </div>
      {window.innerWidth < 992 ? (
        <TokenRenewalBox onEmitTokenValid={onEmitTokenValid} idProfile={user?.idNetwork} socialNetwork={user?.socialNetwork} />
      ) : null}
    </div>
  )
}
